import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import T from '../../../Locale';
class ImageAttachment extends Component {
    constructor(props) {
        super(props);
        this.removeImage = this.removeImage.bind(this);
    }
    removeImage() {
        const { setData } = this.props;
        setData('image', null);
    }
    render() {
        const { image } = this.props;
        return (_jsxs("div", Object.assign({ className: "columns small-2 values-delete-button__wrapper" }, { children: [_jsx("i", { className: "fa fa-trash-o icon-delete values-delete-button", "aria-hidden": "true", onClick: () => this.removeImage(), title: T.translate('values.imageDelete') }), _jsx("img", { src: image, alt: "" })] })));
    }
}
ImageAttachment.propTypes = {
    image: PropTypes.string.isRequired,
    setData: PropTypes.func.isRequired
};
export default ImageAttachment;
